import Head from 'next/head';
import * as React from 'react';
import { useIntl } from 'react-intl';

export default function PlaylistsHead(): React.ReactNode {
  const { formatMessage } = useIntl();
  const title = formatMessage({ defaultMessage: 'Browse playlists' });
  const description = formatMessage({
    defaultMessage:
      'TED.com, home of TED Talks, is a global initiative about ideas worth spreading via TEDx, The Audacious Project, TED Books, TED Conferences, TED-Ed and more.'
  });
  return (
    <Head>
      <title>{title}</title>
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta name="description" content={description} />
    </Head>
  );
}
